import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

import { RecurrenceModificationMode } from "@/types/enums/recurrence-modification-mode";

interface RecurrenceScopeSelectorProps {
  mode: RecurrenceModificationMode;
  onModeChange: (mode: RecurrenceModificationMode) => void;
  isDisabled: boolean;
  /**
   * Whether to offer "All events". The whole series includes occurrences that
   * have already happened, so destructive actions leave this off — cancelling or
   * deleting a series means "from here forward", never reaching back into
   * completed visits.
   */
  allowAllEvents?: boolean;
}

export default function RecurrenceScopeSelector({
  mode,
  onModeChange,
  isDisabled,
  allowAllEvents = true,
}: RecurrenceScopeSelectorProps) {
  return (
    <>
      <div className="mt-4 space-y-2">
        <RadioGroup
          value={mode}
          onValueChange={(val) =>
            onModeChange(val as RecurrenceModificationMode)
          }
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem
              id="recurrence-scope-this"
              value={RecurrenceModificationMode.THIS}
              disabled={isDisabled}
            />
            <Label htmlFor="recurrence-scope-this" className="cursor-pointer">
              This event
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem
              id="recurrence-scope-future"
              value={RecurrenceModificationMode.FUTURE}
              disabled={isDisabled}
            />
            <Label htmlFor="recurrence-scope-future" className="cursor-pointer">
              This and following events
            </Label>
          </div>
          {allowAllEvents && (
            <div className="flex items-center space-x-2">
              <RadioGroupItem
                id="recurrence-scope-all"
                value={RecurrenceModificationMode.ALL}
                disabled={isDisabled}
              />
              <Label htmlFor="recurrence-scope-all" className="cursor-pointer">
                All events
              </Label>
            </div>
          )}
        </RadioGroup>
      </div>
    </>
  );
}
